import React, { useState } from "react";

const FillMissingInTable = ({
  questionNumber = "",
  answers = [],
  correctAnswers = [],
  onCalculateScore,
}) => {
  // Extract column names and rows from answers
  const [columns, ...rows] = answers;

  // Initialize state to store input values
  const [inputValues, setInputValues] = useState(
    rows.flatMap(row => row.slice(1)).filter(value => value.includes("_")).map(() => "")
  );

  // Handle input change
  const handleInputChange = (index, value) => {
    const updatedValues = [...inputValues];
    updatedValues[index] = value;
    setInputValues(updatedValues);
  };

  return (
    <div className="p-3 w-full bg-white font-inter rounded-md shadow-md">
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="border border-gray-300 p-2 text-left"></th>
              {columns.map((col, index) => (
                <th key={index} className="border border-gray-300 p-2 text-left">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, colIndex) => {
                  if (colIndex === 0) {
                    return <td key={colIndex} className="border border-gray-300 p-2">{cell}</td>;
                  } else if (cell.includes("_")) {
                    const inputIndex = rows.slice(0, rowIndex).flatMap(r => r.slice(1)).filter(value => value.includes("_")).length + row.slice(1, colIndex).filter(value => value.includes("_")).length;
                    const parts = cell.split("_");
                    return (
                      <td key={colIndex} className="border border-gray-300 p-2">
                        {parts[0]}
                        <input
                          type="text"
                          className="w-full h-8 border border-gray-400 px-2 text-sm rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                          placeholder="?"
                          value={inputValues[inputIndex]}
                          onChange={(e) => handleInputChange(inputIndex, e.target.value)}
                        />
                        {parts[1]}
                      </td>
                    );
                  } else {
                    return <td key={colIndex} className="border border-gray-300 p-2">{cell}</td>;
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Finish Button */}
      <div className="mt-4 flex justify-end">
        <button
          className="w-28 h-10 bg-blue-500 text-white rounded-md flex items-center justify-center cursor-pointer hover:bg-blue-600 transition text-lg"
          onClick={() => onCalculateScore(1, questionNumber, inputValues, correctAnswers)}
        >
          Finish
        </button>
      </div>
    </div>
  );
};

export default FillMissingInTable;